module.exports = __webpack_public_path__ + "static/global_adjustments-f1ab3848df0190db777d0d4934f024f3.webm";